<template>
  <div class="container-fluid mt-2">
    <h2>Data Graph</h2>
    <div class="btn-toolbar mt-3 mb-2 justify-content-between">
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text">Name</span>
            </div>
            <input v-model="datagraph.name" type="text" class="form-control"/>
        </div>
        <div class="row">
            <button @click="syncGraph" class="btn btn-secondary mr-2">Synchronisieren</button>
            <div class="form-check">
                <input v-model="reindex" type="checkbox" class="form-check-input" id="reindexCheck"/>
                <label for="reindexCheck">Reindex</label>
            </div>
        </div>
        <button @click="saveGraph" class="btn btn-primary">Speichern</button>
    </div>
    <br/>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md">
                <h4>Tabellen</h4>
                <div class="form-group">
                    <label>Tabelle auswählen</label>
                    <select v-model="selectedTable" class="form-control">
                        <option v-for="t in tables" :key="t.name" :value="t.name">{{t.name}}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Semantischer Name</label>
                    <div class="input-group">
                        <input type="text" v-model="tableSemiName" class="form-control"/>
                        <div class="input-group-append">
                            <button @click="addTable" class="btn btn-secondary" type="button">Add</button>
                        </div>
                    </div>
                </div>
                <ul class="list-group">
                    <li class="list-group-item" v-for="(v,k) in datagraph.subgraphs" :key="k">
                        <div class="justify-content-between d-flex">
                            <div>
                                <span>{{ v.tableId }}</span><br/>
                                <span class="text-sm text-muted">Storage: {{ k }}</span>
                            </div>
                            <button @click="remTable(k)" class="btn btn-sm btn-danger">Delete</button>
                            <button @click="openTable(k)" class="btn btn-sm btn-primary">Edit</button>
                        </div>
                        <div v-if="v.vertices">
                            <div class="form-group">
                                <label>ID Spalte</label>
                                <input v-model="v.vertices.id" type="text" class="form-control"/>
                            </div>
                            <div class="form-group">
                                <label>Beschreibung</label>
                                <input v-model="v.vertices.description" type="text" class="form-control"/>
                            </div>
                            <div class="form-group">
                                <label>Namens Spalte</label>
                                <input v-model="v.vertices.nameColumn" type="text" class="form-control"/>
                            </div>
                        </div> 
                    </li>
                </ul>
            </div>
            <div class="col-md">
                <h4>Tabelle</h4>
                <div class="form-group">
                    <label>Eindeutiger Name</label>
                    <input type="text" class="form-control" v-model="editTable.tableId" @blur="updateEditEntry"/>
                </div>
                <h4>Eigenschaften</h4>
                <div class="form-group">
                    <label>Spalte auswählen</label>
                    <select v-model="editColumn" v-if="editTable.name && editTable.tableschema" class="form-control">
                        <option v-for="(col,index) in editTable.tableschema.properties" :key="index">
                            {{ col.name }}
                        </option>
                    </select>
                    <select v-else class="form-control"></select>
                </div>
                <div class="form-group">
                    <label>Beschreibung</label>
                    <input v-model="editDescription" type="text" class="form-control"/>
                </div>
                <div class="form-group">
                    <label>Semantischer Name</label>
                    <div class="input-group">
                        <input v-model="editProperty" type="text" class="form-control"/>
                        <div class="input-group-append">
                            <button @click="addProperty" class="btn btn-secondary" type="button">Add</button>
                        </div>
                    </div>
                </div>
                <ul v-if="editTable.vertices && editTable.vertices.properties" class="list-group">
                    <li v-for="(v,k) in editTable.vertices.properties" :key="k" class="list-group-item justify-content-between d-flex">
                        <span>{{  v.name }}</span>
                        <span>{{  v.column }}</span>
                        <button @click="remProperty(k)" class="btn btn-sm btn-danger">Delete</button>
                    </li>
                </ul>
            </div>
            <div class="col-md">
                <h4>Verbindungen</h4>
                <div class="form-group">
                    <label>Name</label>
                    <div class="input-group">
                        <input v-model="edgeLabel" type="text" class="form-control"/>
                        <div class="input-group-append">
                            <button @click="addEdge" class="btn btn-secondary" type="button">Add</button>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label>ID Spalte</label>
                    <select v-model="edgeIDColumn" v-if="editTable.name" class="form-control" id="esourceColumn">
                        <option v-for="(col,index) in schemaCache[editTable.name].properties" :key="index" :value="col.name">
                            {{ col.name }}
                        </option>
                    </select>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Quelle (Tabelle)</label>
                            <select v-model="edgeSourceTable" class="form-control" id="esourceTable">
                                <option v-for="(v,k) in datagraph.subgraphs" :key="k" :value="k">{{k}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <label>Quelle (Spalte)</label>
                            <select v-model="edgeSourceProp" v-if="editTable.name" class="form-control" id="esourceColumn">
                                <option v-for="(col,index) in schemaCache[editTable.name].properties" :key="index">
                                    {{ col.name }}
                                </option>
                            </select>
                            <select v-else class="form-control"></select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Ziel (Tabelle)</label>
                            <select v-model="edgeTargetTable" class="form-control" id="etargetTable">
                                <option v-for="(v,k) in datagraph.subgraphs" :key="k" :value="k">{{k}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <label>Ziel (Spalte)</label>
                            <select v-model="edgeTargetProp" v-if="editTable.name" class="form-control" id="etargetColumn">
                                <option v-for="(col,index) in schemaCache[editTable.name].properties" :key="index">
                                    {{ col.name }}
                                </option>
                            </select>
                            <select v-else class="form-control"></select>
                        </div>
                    </div>
                </div>
                <ul class="list-group">
                    <li v-for="e in editTable.edges" :key="e.label" class="list-group-item">
                        <span>{{ e.label }}</span><br/>
                        <div class="justify-content-between d-flex">
                            <span class="text-small text-muted">{{ e.sourceName + '.' + e.source }} => {{ e.targetName + '.' + e.target }}</span>
                            <button @click={remEdge(e.label)} class="btn btn-sm btn-danger"><font-awesome-icon icon="trash"/></button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import datagraph from '../../modules/datagraph';
import datamap from '@/modules/datamap.js'

export default {
  name: 'DataGraphEditor',
  data() {
    return {
      datagraph: { id: 0, name: "", subgraphs: {} },
      tables: [],
      selectedTable: '',
      tableSemiName: "",
      editColumn: "",
      editDescription: "",
      editProperty: "",
      tablesCache: {},
      schemaCache: {},
      edgeName: {},
      edgeLabel: '',
      reindex: false,
      edgeSourceTable: '',
      edgeTargetTable: '',
      edgeSourceProp: '',
      edgeTargetProp: '',
      edgeIDColumn: '',
      editTable: {"tableschema":{}}
    }
  },
  created: function() {
    this.loadTables();
  },
  mounted: function() {
    console.log("mounted",this.$route.params);
    if (this.$route.params.id && this.$route.params.id !== 0) {
        this.loadGraph(this.$route.params.id);
    }
  },
  methods: {
    loadTables() {
        var self = this;
        datamap.listtables(this,0,500,'name','',function(data) {
            self.tables = data;
        });
    },
    syncGraph() {
        console.log('Synchronize Graph: ' + this.datagraph.id + "/" + this.reindex);
        datagraph.synchronize(this.datagraph.id,this.reindex);
    },
    saveGraph() {
        console.log(this.datagraph);
        var self = this;
        datagraph.save(this.datagraph).then(function(data) {
            self.datagraph = data;
            self.$bvToast.toast('Graph gespeichert',{variant:'success', title:'DataGraph'});
        });
    },
    loadGraph(id) {
        var self = this;
        console.log('load: ' + id);
        datagraph.load(id).then((data) => {
            console.log('set data',data);
            self.datagraph = data;
        })
    },
    createTableSchema(tconf) {
        var schema = {"properties":{}};
        if (tconf.config && tconf.config.tables) {
            for (var t in tconf.config.tables) {
                var stable = tconf.config.tables[t];
                if (stable.table && stable.table.properties) {
                    for (var p in stable.table.properties) {
                        var prop = stable.table.properties[p];
                        console.log(prop);
                        if (!schema.properties[prop.name]) {
                            schema.properties[prop.name] = prop;
                        }
                    }
                }
            }
        }
        console.log('Cache Schema: ' + tconf.name,schema);
        this.schemaCache[tconf.name] = schema;
        return schema;
    },
    remTable(key) {
        delete this.datagraph.subgraphs[key];
        this.$forceUpdate();
    },
    openTable(key) {
        this.editTable.name = key;
        if (this.tablesCache[key]) {
            this.editTable.tableschema = this.createTableSchema(this.tablesCache[key]);
            this.editTable.vertices = this.datagraph.subgraphs[key].vertices || {};
            this.editTable.edges = this.datagraph.subgraphs[key].edges || {};
            this.editTable.tableId = this.datagraph.subgraphs[key].tableId;
            console.log("tableID: ",this.editTable.tableId);
            this.editTable.useAll = true;
            console.log(this.editTable);
            this.$forceUpdate();
        } else {
            this.cacheTableKey(key,false);
        }
    },
    cacheTableKey(key,edit) {
        var self = this;
        datamap.loadtable(key,this,function(data) {
            console.log('loaded table config',data);
            self.tablesCache[key] = data;
            self.createTableSchema(data);
            if (edit)
                self.editTable.tableschema = self.schemaCache[data.name];
        })
    },
    updateEditEntry() {
        console.log('update table edit: ',this.editTable);
        this.datagraph.subgraphs[this.editTable.name] = this.editTable;
    },
    remEdge(key) {
        console.log('rem edge: ' + key);
        this.editTable.edges = this.editTable.edges || {};
        delete this.editTable.edges[key];
    },
    addEdge() {
        console.log(this);
        var edge = {
            "label":this.edgeLabel,
            "source": this.edgeSourceProp,
            "sourceName": this.edgeSourceTable,
            "target": this.edgeTargetProp,
            "targetName": this.edgeTargetTable,
            "idColumn": this.edgeIDColumn
        };
        console.log(edge);
        this.editTable.edges = this.editTable.edges || {};
        this.editTable.edges[this.edgeLabel] = edge;
        console.log(this.editTable);
        this.datagraph.subgraphs[this.editTable.name] = this.editTable;
        this.$forceUpdate();
    },
    addProperty() {
        console.log('add property: ',this.editColumn,this.editProperty);
        this.editTable.vertices.properties = this.editTable.vertices.properties || {};
        this.editTable.vertices.properties[this.editProperty] = {
            "name":this.editProperty,
            "column":this.editColumn,
            "description":this.editDescription
        };
        this.datagraph.subgraphs[this.editTable.name] = this.editTable;
        this.$forceUpdate();
    },
    remProperty(key) {
        this.editTable.vertices.properties = this.editTable.vertices.properties || {};
        delete this.editTable.vertices.properties[key];
        this.datagraph.subgraphs[this.editTable.name] = this.editTable;
        this.$forceUpdate();
    },
    addTable() {
        console.log('add table:',this.selectedTable,this.tableSemiName);
        if (this.datagraph.subgraphs[this.selectedTable]) {
            this.$bvToast.toast('Tabelle bereits enthalten.',{variant:'warning', title:'Tabellen'});
            return;
        }
        this.datagraph.subgraphs[this.selectedTable] = {"tableId":this.tableSemiName,vertices: {"useAll":true}, edges: {} };
        this.cacheTableKey(this.selectedTable,false);
        // force because subobject change not triggered automatic 
        this.$forceUpdate();
    }
  }
}
</script>